<template>
<div>
  <v-img :src="`${baseUrl}painel/${link}?token=${token}`" />
</div>
</template>

<script>
import {
  getToken
} from '../../store/auth'
import {
  baseURL
} from '../../services/config'

export default {
  name: 'anuncioImagem',
  props: {
    link: String
  },
  data() {
    return {
      baseUrl: baseURL,
      token: getToken()
    }
  },

  watch: {
    link(val) {
      if (val !== '') {
        setTimeout(() => {
          console.log('stopImg');
          // this.link = ''
          this.$emit('stopImg', '')
        }, 500);
      }
    }
  },

  methods: {

  }
}
</script>
